import { default as Page } from '@atlaskit/pagination';
import classNames from 'classnames/bind';
import range from 'lodash/range';

import { CoreIcon } from '@autopass-web/mochi-icons';

import styles from './index.module.sass';

const cx = classNames.bind(styles);

const Pagination = ({ currentPage, totalPage, onPageSelected }: any) => {
  const pageItem = (props: any) => {
    const pageClasses = cx({
      page: true,
      active: currentPage === props.page,
    });
    return (
      <div className={pageClasses} onClick={props.onClick}>
        {props.page}
      </div>
    );
  };

  const pageNext = (props: any) => {
    const disable = currentPage === totalPage;
    const onClick = disable ? undefined : props.onClick;
    const nextClass = cx({
      arrow: true,
      disable,
    });

    return (
      <CoreIcon
        className={nextClass}
        src="/assets/chevron-right.svg"
        onClick={onClick}
      />
    );
  };

  const pagePrevious = (props: any) => {
    const disable = currentPage === 1;
    const onClick = disable ? undefined : props.onClick;
    const previousClass = cx({
      arrow: true,
      previous: true,
      disable,
    });

    return (
      <CoreIcon
        className={previousClass}
        src="/assets/chevron-left.svg"
        onClick={onClick}
      />
    );
  };

  // current page or total page 小於 0 都是異常狀態
  // 目前篩選不到資料時 api total page 會給 0 所以當其一小於 0 則隱藏分頁
  if (currentPage <= 0 || totalPage <= 0) {
    return <></>;
  }

  const paginationClass = cx({
    pagination: true,
  });

  return (
    <div className={paginationClass}>
      <Page
        max={6}
        pages={range(1, totalPage + 1)}
        onChange={(_, newPage) => onPageSelected(newPage)}
        selectedIndex={currentPage - 1}
        components={{
          Page: pageItem,
          Previous: pagePrevious,
          Next: pageNext,
        }}
      />
    </div>
  );
};
export default Pagination;
